import classNames from 'classnames';
import styles from './ConcernQuery.module.css';
import { Button, Space, Form, Modal } from 'antd';
import { useState, useRef, useEffect } from 'react';
import SessionDefinition from 'src/components/Query/SessionDefinition';
import type { FormInstance } from 'antd/es/form';
import VehicleDefinition from '../../components/Query/VehicleDefinition';
import ConcernDefinition from 'src/components/Query/ConcernDefinition';
import FinalSummary from 'src/components/Query/FinalSummary';
import { getFinalResultCost } from 'src/app/query.service';

interface FormData {
  [key: string]: any;
}
// type FormData = { [key: string]: unknown } | [];

interface Cost {
  queryCost: string;
  isCostThresholdCrossed: boolean;
}
interface ResettableComponent {
  reset: () => void;
}

const ConcernQuery = () => {
  const [activeComponent, setActiveComponent] = useState<number>(1);
  const [formData, setFormData] = useState<FormData>({});
  const [finalStep, setFinalStep] = useState(false);
  const [costData, setCostData] = useState<Cost[]>([]);
  const [isModalOpen, setModal] = useState(false);
  const [form] = Form.useForm<FormInstance>();
  const sessionRef = useRef<ResettableComponent>(null);
  const vehicleRef = useRef<ResettableComponent>(null);
  const concernRef = useRef<ResettableComponent>(null);
  const handleNext = (newData: FormData) => {
    setFormData((prevData) => ({ ...prevData, ...newData }));
    setActiveComponent((prevActiveComponent) => prevActiveComponent + 1);
  };
  const concernDefinitionData = (newData: FormData) => {
    setFormData((prevData) => ({ ...prevData, ...newData }));
  };
  const handleBack = () => {
    setActiveComponent((prevActiveComponent) => prevActiveComponent - 1);
  };
  const [payload, setPayload] = useState<FormData>({});

  const generatePayload = () => {
    const data = {
      concernName: formData.concernName || null,
      hardwarePartNumber: formData.hardwarePartNumber || null,
      softwarePartNumber: formData.softwarePartNumber || null,
      ecuCalibrationNumber: formData.ecuCalibrationNumber || null,
      ecuSerialNumber: formData.ecuSerialNumber || null,
      dateFrom: formData.dateFrom || null,
      dateTo: formData.dateTo || null,
      sourceSoftwareVersion: formData.sourceSoftwareVersion || null,
      sourceType: formData.sourceType || null,
      bodyStyle: formData.bodyStyle || null,
      brand: formData.brand || null,
      driver: formData.driver || null,
      emission: formData.emission || null,
      engine: formData.engine || null,
      enginePowertrainDescription: formData.enginePowertrainDescription || null,
      market: formData.market || null,
      model: formData.model || null,
      modelYear: formData.modelYear || null,
      plant: formData.plant || null,
      trim: formData.trim || null,
      transmission: formData.transmission || null,
      vin: formData.vin || null,
      dateRangeOverriden: formData.dateRangeOverriden || null,
    };
    setPayload(data);
    return data;
  };

  const handleStart = async () => {
    const postData: FormData = generatePayload();

    try {
      const vinArray = Array.isArray(postData.vin) ? postData.vin : [];

      // If VINs are provided, skip cost check
      if (vinArray.length > 0) {
        setFinalStep(true);
        return;
      }

      const result: Cost[] = await getFinalResultCost<Cost>('concern', 'final/cost', postData);
      setCostData(result);

      if (result[0]?.isCostThresholdCrossed) {
        setModal(true);
      } else {
        setFinalStep(true);
      }
    } catch (error) {
      console.log('error fetching cost...', error);
    }
  };
  useEffect(() => {
    if (costData[0]?.isCostThresholdCrossed) {
      setModal(true);
    }
  }, [costData]);

  const handleCancel = () => {
    setModal(false);
  };
  const handleStartQuery = () => {
    setModal(false);
    setFinalStep(true);
  };
  const handleReset = () => {
    form.resetFields();
    setFormData({});
    setActiveComponent(1);
    if (sessionRef.current) {
      sessionRef.current.reset();
    }
    if (vehicleRef.current) {
      vehicleRef.current.reset();
    }
    if (concernRef.current) {
      concernRef.current.reset();
    }
  };
  console.log('form...', form);
  return (
    <div className={classNames(styles.ConcernQuery)}>
      {!finalStep && (
        <>
          <SessionDefinition
            ref={sessionRef}
            isActive={activeComponent === 1}
            onNext={handleNext}
            form={form}
            queryType="concern"
          />
          <VehicleDefinition
            ref={vehicleRef}
            isActive={activeComponent === 2}
            onBack={handleBack}
            onNext={handleNext}
            propData={formData}
            form={form}
            queryType="concern"
          />
          <ConcernDefinition
            ref={concernRef}
            isActive={activeComponent === 3}
            onBack={handleBack}
            propData={formData}
            form={form}
            queryType="concern"
            handleNext={concernDefinitionData}
          />
          <div>
            <Space>
              <Button onClick={handleStart} className={styles['ConcernQuery--Buttons']}>
                Start
              </Button>
              <Button className={styles['ConcernQuery--Buttons']} onClick={handleReset}>
                Reset
              </Button>
            </Space>
          </div>
        </>
      )}
      {finalStep && (
        <FinalSummary
          onBack={() => setFinalStep(false)}
          queryType="concern"
          propData={payload}
          filename="Concern_export"
        />
      )}
      <Modal
        title={<h3 style={{ display: 'inline' }}>Query Cost Calculation</h3>}
        open={isModalOpen}
        onCancel={handleCancel}
        footer={null}
      >
        <div>
          Please be advised, this query may cost the company up to $ {costData[0]?.queryCost}. You
          can press &quto;Back&quto; to reduce this Cost by using a smaller date range and/or using
          specific VINs in you query. Please ensure this is business critical before selecting
          Start.
        </div>
        <div style={{ width: '100%' }}>
          <Button
            onClick={() => {
              setModal(false);
              setFinalStep(true);
            }}
            className="ConcernQuery--Buttons"
          >
            Start Query
          </Button>
          <Button
            onClick={() => setModal(false)}
            className="ConcernQuery--Buttons"
            style={{ float: 'right' }}
          >
            Back
          </Button>
        </div>
      </Modal>
    </div>
  );
};
export default ConcernQuery;
